import React, { Component } from 'react';
import './ContactUs.css'
export default class ContactUs extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return <section id="contact">
            <div className="row section-head">
                <div className="ten columns">
                    <p className="lead">
                        Feel free to contact me for any work or suggestions
                        below
                    </p>
                </div>
            </div>
            <div className="row">
                <aside className="eigth columns footer-widgets">
                    <div className="widget">
                        <h4>
                            LinkedIn :   <a href={resumeData.linkedinId}>
                                {resumeData.linkedinId}
                            </a>
                        </h4>
                    </div>
                    <div className="widget" style={{marginTop:'10px'}}>
                        <h4>
                            Skype Join : <a href="https://join.skype.com/invite/YcwabIi9z9TE">
                                https://join.skype.com/invite/YcwabIi9z9TE
                            </a>
                        </h4>
                    </div>
                    <div className="widget" style={{marginTop:'10px'}}>
                        <h4>
                            Email ID :   <span>
                                    <a href={['mailto:', resumeData.email].join('')}>
                                        {resumeData.email}
                                    </a>
                                </span>
                        </h4>
                    </div>
                </aside>
            </div>
        </section>;
  }
}